import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const candidateService = {
    store,
    show,
    update,
    createCandidateUser,
};

const MODULE = {
    CANDIDATE: 'candidates',
};

const API_URL = API.BASE_URL_API + '/v1/fe';

export function store (data) {
    const formData = new FormData();
    formData.append(`_method`, 'POST');

    if (data.candidate) {
        formData.append(`candidate[candidate_job_uuid]`, data.candidate.candidateJobUuid);
        formData.append(`candidate[first_name]`, data.candidate.firstName);
        formData.append(`candidate[last_name]`, data.candidate.lastName);
        if (data.candidate.englishName) formData.append(`candidate[english_name]`, data.candidate.englishName);
        if (data.candidate.phoneCode) formData.append(`candidate[phone_code]`, data.candidate.phoneCode);
        if (data.candidate.phoneIso) formData.append(`candidate[phone_iso]`, data.candidate.phoneIso);
        if (data.candidate.phoneNumber) formData.append(`candidate[phone_number]`, data.candidate.phoneNumber);
        if (data.candidate.homePhoneCode) formData.append(`candidate[home_phone_code]`, data.candidate.homePhoneCode);
        if (data.candidate.homePhoneIso) formData.append(`candidate[home_phone_iso]`, data.candidate.homePhoneIso);
        if (data.candidate.homePhoneNumber) formData.append(`candidate[home_phone_number]`, data.candidate.homePhoneNumber);
        if (data.candidate.email) formData.append(`candidate[email]`, data.candidate.email);
        if (data.candidate.companyEmail) formData.append(`candidate[company_email]`, data.candidate.companyEmail);
        if (data.candidate.birthDate) formData.append(`candidate[birth_date]`, data.candidate.birthDate);
        if (data.candidate.birthPlace) formData.append(`candidate[birth_place]`, data.candidate.birthPlace);
        if (data.candidate.malaysiaId) formData.append(`candidate[malaysia_id]`, data.candidate.malaysiaId);
        if (data.candidate.passportNumber) formData.append(`candidate[passport_number]`, data.candidate.passportNumber);
        if (data.candidate.passportExpiredDate) formData.append(`candidate[passport_expired_date]`, data.candidate.passportExpiredDate);
        if (data.candidate.maritalStatus != null) formData.append(`candidate[marital_status]`, data.candidate.maritalStatus);
        if (data.candidate.nationality) formData.append(`candidate[nationality]`, data.candidate.nationality);
        if (data.candidate.race) formData.append(`candidate[race]`, data.candidate.race);
        if (data.candidate.ethnicity) formData.append(`candidate[ethnicity]`, data.candidate.ethnicity);
        if (data.candidate.religion) formData.append(`candidate[religion]`, data.candidate.religion);
        if (data.candidate.expectedSalary) formData.append(`candidate[expected_salary]`, data.candidate.expectedSalary);
        if (data.candidate.address1) formData.append(`candidate[address_1]`, data.candidate.address1);
        if (data.candidate.address2) formData.append(`candidate[address_2]`, data.candidate.address2);
        if (data.candidate.address3) formData.append(`candidate[address_3]`, data.candidate.address3);
        if (data.candidate.city) formData.append(`candidate[city]`, data.candidate.city);
        if (data.candidate.state) formData.append(`candidate[state]`, data.candidate.state);
        if (data.candidate.postcode) formData.append(`candidate[postcode]`, data.candidate.postcode);
        if (data.candidate.country) formData.append(`candidate[country]`, data.candidate.country);
        if (data.candidate.gender != null) formData.append(`candidate[gender]`, data.candidate.gender);
        if (data.candidate.callDuringWork != null) formData.append(`candidate[call_during_work]`, data.candidate.callDuringWork);
        if (data.candidate.willingOt != null) formData.append(`candidate[willing_ot]`, data.candidate.willingOt);
        if (data.candidate.willingToRelocate != null) formData.append(`candidate[willing_to_relocate]`, data.candidate.willingToRelocate);
        if (data.candidate.isApplicationCompleted != null) formData.append(`candidate[is_application_completed]`, data.candidate.isApplicationCompleted);
        if (data.candidate.declarationSignature) formData.append(`candidate[declaration_signature]`, data.candidate.declarationSignature);
        if (data.candidate.photo instanceof File) formData.append(`candidate[photo]`, data.candidate.photo);
        if (data.candidate.resume instanceof File) formData.append(`candidate[resume]`, data.candidate.resume);
        if (data.candidate.signatureImage) formData.append(`candidate[signature_image]`, data.candidate.signatureImage);
    }

    (data.languages ?? []).forEach((item, index) => {
        if (item.name) formData.append(`languages[${index}][name]`, item.name);
        if (item.write != null) formData.append(`languages[${index}][write]`, item.write);
        if (item.read != null) formData.append(`languages[${index}][read]`, item.read);
        if (item.spoken != null) formData.append(`languages[${index}][spoken]`, item.spoken);
        if (item.listen != null) formData.append(`languages[${index}][listen]`, item.listen);
    });

    (data.educations ?? []).forEach((item, index) => {
        if (item.name) formData.append(`educations[${index}][name]`, item.name);
        if (item.field) formData.append(`educations[${index}][field]`, item.field);
        if (item.institute) formData.append(`educations[${index}][institute]`, item.institute);
        if (item.location) formData.append(`educations[${index}][location]`, item.location);
        if (item.grade) formData.append(`educations[${index}][grade]`, item.grade);
        if (item.startDate) formData.append(`educations[${index}][start_date]`, item.startDate);
        if (item.endDate) formData.append(`educations[${index}][end_date]`, item.endDate);
        if (item.description) formData.append(`educations[${index}][description]`, item.description);
    });

    (data.experiences ?? []).forEach((item, index) => {
        if (item.name) formData.append(`experiences[${index}][name]`, item.name);
        if (item.company) formData.append(`experiences[${index}][company]`, item.company);
        if (item.address) formData.append(`experiences[${index}][address]`, item.address);
        if (item.location) formData.append(`experiences[${index}][location]`, item.location);
        if (item.startDate) formData.append(`experiences[${index}][start_date]`, item.startDate);
        if (item.endDate) formData.append(`experiences[${index}][end_date]`, item.endDate);
        if (item.department) formData.append(`experiences[${index}][department]`, item.department);
        if (item.salary) formData.append(`experiences[${index}][salary]`, item.salary);
        if (item.periodNoticeMonth) formData.append(`experiences[${index}][period_notice_month]`, item.periodNoticeMonth);
        if (item.reasonForLeaving) formData.append(`experiences[${index}][reason_for_leaving]`, item.reasonForLeaving);
        if (item.isCurrent != null) formData.append(`experiences[${index}][is_current]`, item.isCurrent);
        if (item.serviceSummary) formData.append(`experiences[${index}][service_summary]`, item.serviceSummary);
        if (item.yearsOfService) formData.append(`experiences[${index}][years_of_service]`, item.yearsOfService);
    });

    (data.families ?? []).forEach((item, index) => {
        if (item.name) formData.append(`families[${index}][name]`, item.name);
        if (item.relationship) formData.append(`families[${index}][relationship]`, item.relationship);
        if (item.occupation) formData.append(`families[${index}][occupation]`, item.occupation);
        if (item.phoneNumber) formData.append(`families[${index}][phone_number]`, item.phoneNumber);
        if (item.phoneCode) formData.append(`families[${index}][phone_code]`, item.phoneCode);
        if (item.phoneIso) formData.append(`families[${index}][phone_iso]`, item.phoneIso);
        if (item.address) formData.append(`families[${index}][address]`, item.address);
        if (item.isEmergency != null) formData.append(`families[${index}][is_emergency]`, item.isEmergency);
    });

    if (data.medical) {
        if (data.medical.physicalImpairmentDisease != null) formData.append(`medical[physical_impairment_disease]`, data.medical.physicalImpairmentDisease);
        if (data.medical.physicalImpairmentDiseaseRemark) formData.append(`medical[physical_impairment_disease_remark]`, data.medical.physicalImpairmentDiseaseRemark);
        if (data.medical.seriousIllness != null) formData.append(`medical[serious_illness]`, data.medical.seriousIllness);
        if (data.medical.seriousIllnessRemark) formData.append(`medical[serious_illness_remark]`, data.medical.seriousIllnessRemark);
        if (data.medical.medicationAllergy != null) formData.append(`medical[medication_allergy]`, data.medical.medicationAllergy);
        if (data.medical.medicationAllergyRemark) formData.append(`medical[medication_allergy_remark]`, data.medical.medicationAllergyRemark);
        if (data.medical.bloodType) formData.append(`medical[blood_type]`, data.medical.bloodType);
        if (data.medical.isPregnant != null) formData.append(`medical[is_pregnant]`, data.medical.isPregnant);
        if (data.medical.pregnantMonth) formData.append(`medical[pregnant_month]`, data.medical.pregnantMonth);
    }

    return apiHelper(API_URL).post(`/${MODULE.CANDIDATE}`, formData);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE}/${uuid}`);
}

export function update (data) {
    const formData = new FormData();
    formData.append(`_method`, 'PUT');

    if (data.candidate) {
        formData.append(`candidate[candidate_job_uuid]`, data.candidate.candidateJobUuid);
        formData.append(`candidate[first_name]`, data.candidate.firstName);
        formData.append(`candidate[last_name]`, data.candidate.lastName);
        if (data.candidate.englishName) formData.append(`candidate[english_name]`, data.candidate.englishName);
        if (data.candidate.phoneCode) formData.append(`candidate[phone_code]`, data.candidate.phoneCode);
        if (data.candidate.phoneIso) formData.append(`candidate[phone_iso]`, data.candidate.phoneIso);
        if (data.candidate.phoneNumber) formData.append(`candidate[phone_number]`, data.candidate.phoneNumber);
        if (data.candidate.homePhoneCode) formData.append(`candidate[home_phone_code]`, data.candidate.homePhoneCode);
        if (data.candidate.homePhoneIso) formData.append(`candidate[home_phone_iso]`, data.candidate.homePhoneIso);
        if (data.candidate.homePhoneNumber) formData.append(`candidate[home_phone_number]`, data.candidate.homePhoneNumber);
        if (data.candidate.email) formData.append(`candidate[email]`, data.candidate.email);
        if (data.candidate.companyEmail) formData.append(`candidate[company_email]`, data.candidate.companyEmail);
        if (data.candidate.birthDate) formData.append(`candidate[birth_date]`, data.candidate.birthDate);
        if (data.candidate.birthPlace) formData.append(`candidate[birth_place]`, data.candidate.birthPlace);
        if (data.candidate.malaysiaId) formData.append(`candidate[malaysia_id]`, data.candidate.malaysiaId);
        if (data.candidate.passportNumber) formData.append(`candidate[passport_number]`, data.candidate.passportNumber);
        if (data.candidate.passportExpiredDate) formData.append(`candidate[passport_expired_date]`, data.candidate.passportExpiredDate);
        if (data.candidate.maritalStatus != null) formData.append(`candidate[marital_status]`, data.candidate.maritalStatus);
        if (data.candidate.nationality) formData.append(`candidate[nationality]`, data.candidate.nationality);
        if (data.candidate.race) formData.append(`candidate[race]`, data.candidate.race);
        if (data.candidate.ethnicity) formData.append(`candidate[ethnicity]`, data.candidate.ethnicity);
        if (data.candidate.religion) formData.append(`candidate[religion]`, data.candidate.religion);
        if (data.candidate.expectedSalary) formData.append(`candidate[expected_salary]`, data.candidate.expectedSalary);
        if (data.candidate.address1) formData.append(`candidate[address_1]`, data.candidate.address1);
        if (data.candidate.address2) formData.append(`candidate[address_2]`, data.candidate.address2);
        if (data.candidate.address3) formData.append(`candidate[address_3]`, data.candidate.address3);
        if (data.candidate.city) formData.append(`candidate[city]`, data.candidate.city);
        if (data.candidate.state) formData.append(`candidate[state]`, data.candidate.state);
        if (data.candidate.postcode) formData.append(`candidate[postcode]`, data.candidate.postcode);
        if (data.candidate.country) formData.append(`candidate[country]`, data.candidate.country);
        if (data.candidate.gender != null) formData.append(`candidate[gender]`, data.candidate.gender);
        if (data.candidate.callDuringWork != null) formData.append(`candidate[call_during_work]`, data.candidate.callDuringWork);
        if (data.candidate.willingOt != null) formData.append(`candidate[willing_ot]`, data.candidate.willingOt);
        if (data.candidate.willingToRelocate != null) formData.append(`candidate[willing_to_relocate]`, data.candidate.willingToRelocate);
        if (data.candidate.isApplicationCompleted != null) formData.append(`candidate[is_application_completed]`, data.candidate.isApplicationCompleted);
        if (data.candidate.declarationSignature) formData.append(`candidate[declaration_signature]`, data.candidate.declarationSignature);
        if (data.candidate.photo instanceof File) formData.append(`candidate[photo]`, data.candidate.photo);
        if (data.candidate.resume instanceof File) formData.append(`candidate[resume]`, data.candidate.resume);
        if (data.candidate.signatureImage) formData.append(`candidate[signature_image]`, data.candidate.signatureImage);
    }

    (data.languages ?? []).forEach((item, index) => {
        if (item.uuid) formData.append(`languages[${index}][uuid]`, item.uuid);
        if (item.name) formData.append(`languages[${index}][name]`, item.name);
        if (item.write != null) formData.append(`languages[${index}][write]`, item.write);
        if (item.read != null) formData.append(`languages[${index}][read]`, item.read);
        if (item.spoken != null) formData.append(`languages[${index}][spoken]`, item.spoken);
        if (item.listen != null) formData.append(`languages[${index}][listen]`, item.listen);
    });

    (data.educations ?? []).forEach((item, index) => {
        if (item.uuid) formData.append(`educations[${index}][uuid]`, item.uuid);
        if (item.name) formData.append(`educations[${index}][name]`, item.name);
        if (item.field) formData.append(`educations[${index}][field]`, item.field);
        if (item.institute) formData.append(`educations[${index}][institute]`, item.institute);
        if (item.location) formData.append(`educations[${index}][location]`, item.location);
        if (item.grade) formData.append(`educations[${index}][grade]`, item.grade);
        if (item.startDate) formData.append(`educations[${index}][start_date]`, item.startDate);
        if (item.endDate) formData.append(`educations[${index}][end_date]`, item.endDate);
        if (item.description) formData.append(`educations[${index}][description]`, item.description);
    });

    (data.experiences ?? []).forEach((item, index) => {
        if (item.uuid) formData.append(`experiences[${index}][uuid]`, item.uuid);
        if (item.name) formData.append(`experiences[${index}][name]`, item.name);
        if (item.company) formData.append(`experiences[${index}][company]`, item.company);
        if (item.address) formData.append(`experiences[${index}][address]`, item.address);
        if (item.location) formData.append(`experiences[${index}][location]`, item.location);
        if (item.startDate) formData.append(`experiences[${index}][start_date]`, item.startDate);
        if (item.endDate) formData.append(`experiences[${index}][end_date]`, item.endDate);
        if (item.department) formData.append(`experiences[${index}][department]`, item.department);
        if (item.salary) formData.append(`experiences[${index}][salary]`, item.salary);
        if (item.periodNoticeMonth) formData.append(`experiences[${index}][period_notice_month]`, item.periodNoticeMonth);
        if (item.reasonForLeaving) formData.append(`experiences[${index}][reason_for_leaving]`, item.reasonForLeaving);
        if (item.isCurrent != null) formData.append(`experiences[${index}][is_current]`, item.isCurrent);
        if (item.serviceSummary) formData.append(`experiences[${index}][service_summary]`, item.serviceSummary);
        if (item.yearsOfService) formData.append(`experiences[${index}][years_of_service]`, item.yearsOfService);
    });

    (data.families ?? []).forEach((item, index) => {
        if (item.uuid) formData.append(`families[${index}][uuid]`, item.uuid);
        if (item.name) formData.append(`families[${index}][name]`, item.name);
        if (item.relationship) formData.append(`families[${index}][relationship]`, item.relationship);
        if (item.occupation) formData.append(`families[${index}][occupation]`, item.occupation);
        if (item.phoneNumber) formData.append(`families[${index}][phone_number]`, item.phoneNumber);
        if (item.phoneCode) formData.append(`families[${index}][phone_code]`, item.phoneCode);
        if (item.phoneIso) formData.append(`families[${index}][phone_iso]`, item.phoneIso);
        if (item.address) formData.append(`families[${index}][address]`, item.address);
        if (item.isEmergency != null) formData.append(`families[${index}][is_emergency]`, item.isEmergency);
    });

    if (data.medical) {
        if (data.medical.smoking != null) formData.append(`medical[smoking]`, data.medical.smoking);
        if (data.medical.physicalImpairmentDisease != null) formData.append(`medical[physical_impairment_disease]`, data.medical.physicalImpairmentDisease);
        if (data.medical.physicalImpairmentDiseaseRemark) formData.append(`medical[physical_impairment_disease_remark]`, data.medical.physicalImpairmentDiseaseRemark);
        if (data.medical.seriousIllness != null) formData.append(`medical[serious_illness]`, data.medical.seriousIllness);
        if (data.medical.seriousIllnessRemark) formData.append(`medical[serious_illness_remark]`, data.medical.seriousIllnessRemark);
        if (data.medical.medicationAllergy != null) formData.append(`medical[medication_allergy]`, data.medical.medicationAllergy);
        if (data.medical.medicationAllergyRemark) formData.append(`medical[medication_allergy_remark]`, data.medical.medicationAllergyRemark);
        if (data.medical.bloodType) formData.append(`medical[blood_type]`, data.medical.bloodType);
        if (data.medical.isPregnant != null) formData.append(`medical[is_pregnant]`, data.medical.isPregnant);
        if (data.medical.pregnantMonth) formData.append(`medical[pregnant_month]`, data.medical.pregnantMonth);
    }

    return apiHelper(API_URL).post(`/${MODULE.CANDIDATE}/${data.uuid}`, formData);
}

export function createCandidateUser (data) {
    const request = {
        company_email: data.companyEmail,
    };

    return apiHelper(API_URL).post(`/${MODULE.CANDIDATE}/create-user/${data.uuid}`, request);
}
